// extracted by mini-css-extract-plugin
export default {"icons":"Icons_icons__rSAkt"};